export const Flow = {
  REPORT: 'REPORT',
  BLOCK: 'BLOCK',
  END: 'END',
};

export const Status = {
  STARTED: 'STARTED',
  SELECTED: 'SELECTED',
  SUBMITTED: 'SUBMITTED',
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
};

export const FlagType = {
  PIN: 'PIN',
  COMMENT: 'COMMENT',
  CONVERSATION: 'CONVERSATION',
  DID_IT: 'DID_IT',
};
